import { useQuery } from "@tanstack/react-query";
import type { ApiClient } from "../../../../app/api/client";
import { useAuth } from "../../../../app/auth/useAuth";
import { tenantCapabilityWithFallback } from "../../../../app/auth/tenantCapabilitiesRead";
import { Permissions } from "../../../../app/constants/permissions";
import { globalKey } from "../../../../app/query/queryKeys";

export type CareCase = {
  id: string;
  pipelineId?: string | null;
  pipelineName?: string | null;
  phaseName?: string | null;
  status?: number | null;
  createdAt: string;
  closedAt?: string | null;
  contractPackageId?: string | null;
  assignedAccountName?: string | null;
  nextFollowUpAt?: string | null;
  closeReasonIsWon?: boolean | null;
};
export type CareSummary = { open: CareCase[]; closedCount: number; lastClosed?: CareCase | null };

/** Rechte und Modul der Betreuung — dieselbe Prüfung für Sichtbarkeit des Blocks, Inhalt und Aktionen. */
export function useMemberCareAccess() {
  const auth = useAuth();
  const hasModule = tenantCapabilityWithFallback(auth.info?.capabilities, "memberCare", true);
  return {
    canRead: hasModule && auth.hasAnyPermission(Permissions.MemberCareRead, Permissions.MemberCareWrite, Permissions.All),
    canWrite: hasModule && auth.hasAnyPermission(Permissions.MemberCareWrite, Permissions.All)
  };
}

/** Betreuungsvorgänge einer Person; Schlüssel wie bisher, damit Betreuungsseiten denselben Cache treffen. */
export function useMemberCareSummary(api: Pick<ApiClient, "get">, personId: string, enabled: boolean) {
  return useQuery({
    queryKey: globalKey("persons", personId, "member-care"),
    enabled: enabled && Boolean(personId),
    queryFn: () => api.get<CareSummary>(`/api/v1/leads/by-person/${encodeURIComponent(personId)}/care`)
  });
}
